/**
 * Created by slava on 4/4/17.
 */

const ABExperiments = function () {
    this.groups = {};
    this.futureGroups = {};
    this.updateCallbacks = [];

    const json = bundles.abtest.jsons.abtest_json.getJson();

    this.remoteConfig = new RemoteConfig(json);
};

ABExperiments.STATUS_DRAFT = "draft";
ABExperiments.STATUS_LIVE = "live";
ABExperiments.STATUS_ADOPTED = "adopted";
ABExperiments.STATUS_REVERTED = "reverted";

ABExperiments.prototype.initialize = function (callback) {
    callback = cleverapps.wait(2, callback);

    this.remoteConfig.initialize(callback);
    this.remoteConfig.fetch(callback);
};

ABExperiments.prototype.isInitialized = function () {
    return ABExperiments.Tests !== undefined;
};

ABExperiments.prototype.updateGroups = function () {
    const tests = this.remoteConfig.getJson();
    ABExperiments.Tests = JSON.parse(JSON.stringify(tests));

    for (const id in ABExperiments.Tests) {
        if (typeof ABExperiments.Tests[id] !== "object") {
            delete ABExperiments.Tests[id];
        }
    }

    ABExperiments.initializeTests();

    this.groups = {};
    this.futureGroups = {};

    const data = cleverapps.dataLoader.load(DataLoader.TYPES.ABTEST) || {};

    for (const id in ABExperiments.Tests) {
        const test = ABExperiments.Tests[id];
        const start = test.start ? new Date(test.start).getTime() : 0;

        if (test.status === ABExperiments.STATUS_DRAFT && !cleverapps.config.debugMode) {
            continue;
        }

        if (Date.now() < start || cleverapps.user.registered < start) {
            continue;
        }

        const available = cleverapps.user.checkAvailable(test.available) && cleverapps.paymentsHistory.checkAvailable(test.available);
        const futureAvailable = cleverapps.user.checkAvailable(test.futureAvailable) && cleverapps.paymentsHistory.checkAvailable(test.futureAvailable);

        if (!available && !futureAvailable) {
            continue;
        }

        if (data[id] !== undefined && ![ABExperiments.STATUS_REVERTED, ABExperiments.STATUS_ADOPTED].includes(test.status)) {
            this.setGroup(test, data[id]);
            continue;
        }

        const group = ABExperiments.calcGroup(test);

        if (available) {
            this.setGroup(test, group);
        } else {
            this.setFutureGroup(test, group);
        }
    }

    this.logTestsToConsole();

    this.updateCallbacks.forEach((callback) => {
        callback();
    });
};

ABExperiments.prototype.whenGroupsUpdated = function (callback) {
    this.updateCallbacks.push(callback);

    if (ABExperiments.Tests) {
        callback();
    }
};

ABExperiments.prototype.saveGroup = function (test, group) {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.ABTEST) || {};
    data[test.id] = group;
    cleverapps.dataLoader.save(DataLoader.TYPES.ABTEST, data);
};

ABExperiments.prototype.getGroup = function (test) {
    if (!test) {
        return undefined;
    }

    return this.groups[test.id];
};

ABExperiments.prototype.setGroup = function (test, group) {
    this.groups[test.id] = ABExperiments.parseGroup(group);
};

ABExperiments.prototype.setFutureGroup = function (test, group) {
    this.futureGroups[test.id] = ABExperiments.parseGroup(group);
};

ABExperiments.prototype.allLogEvent = function (event, params = {}) {
    let groups = this.groups;
    if (params.withFutureGroups) {
        groups = { ...this.groups, ...this.futureGroups };
    }

    for (const id in groups) {
        this.logTestEvent(ABExperiments.Tests[id], event, params, groups[id]);
    }
};

ABExperiments.prototype.logTestEvent = function (test, event, params, group) {
    params = params || {};

    group = group || this.getGroup(test);
    if (!test || !group) {
        return;
    }

    if ([ABExperiments.STATUS_ADOPTED, ABExperiments.STATUS_REVERTED].includes(test.status)) {
        return;
    }

    const location = cleverapps.meta.getSelectedLocation();
    const expedition = params.expedition || !location.locationConfig.isMain && location.locationId;
    if (test.expeditions && test.expeditions.indexOf(expedition) === -1) {
        return;
    }

    if (params.eventsGroup && (!test.eventsGroup || !test.eventsGroup.includes(params.eventsGroup))) {
        return;
    }

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.AB_EXPERIMENTS}_${event}`, {
        ...params,
        abTest: test.id,
        abGroup: group.toLowerCase()
    });
};

ABExperiments.prototype.logTestsToConsole = function () {
    for (const id in this.groups) {
        const group = this.groups[id];
        const test = ABExperiments.Tests[id];

        if (!group || !test || [ABExperiments.STATUS_ADOPTED, ABExperiments.STATUS_REVERTED].includes(test.status)) {
            continue;
        }

        console.log("abtest", id, group, test.status);
    }
};

ABExperiments.calcGroup = function (test, userId) {
    if (test.status === ABExperiments.STATUS_REVERTED) {
        return ABExperiments.parseGroup(test.groups[test.groups.length - 1]);
    }

    if (ABExperiments.STATUS_ADOPTED === test.status) {
        if (test.choice) {
            return ABExperiments.parseGroup(test.choice);
        }
        return "A";
    }

    let group;
    const pseudo = PseudoRandom.GET("abexperiments");
    pseudo.seed((userId || connector.platform.getUserID()) + test.id);
    const rnd = pseudo.nextDouble();

    if (test.groups.length > 2) {
        const groupWeight = 1 / test.groups.length;
        group = test.groups[Math.floor(rnd / groupWeight)];
    } else {
        group = rnd > ABExperiments.getAWeight(test) ? "B" : "A";
    }

    return group;
};

ABExperiments.getAWeight = function (test) {
    let weight = test.projectAWeight && test.projectAWeight[cleverapps.config.name];
    if (weight === undefined) {
        weight = test.AWeight;
    }
    return weight <= 0.01 ? 0 : weight;
};

ABExperiments.parseGroup = function (group) {
    if (typeof group === "number") {
        return "ABCD".charAt(group);
    }
    return group;
};

ABExperiments.initializeTests = function () {
    for (const name in ABExperiments.Tests) {
        const test = ABExperiments.Tests[name];
        test.id = name;
        test.groups = test.groups ? test.groups.map((group) => ABExperiments.parseGroup(group)) : ["A", "B"];
        test.AWeight = test.AWeight === undefined ? ABExperiments.DEFAULT_A_WEIGHT : test.AWeight;
        test.status = test.status || (test.available && test.available.debugMode ? ABExperiments.STATUS_DRAFT : ABExperiments.STATUS_LIVE);

        if (test.available) {
            test.futureAvailable = JSON.parse(JSON.stringify(test.available));
            ["forPayer", "actualLevel", "level"].forEach((key) => {
                delete test.futureAvailable[key];
            });
        }
    }
};

ABExperiments.DEFAULT_A_WEIGHT = 0;

if (typeof cc === "undefined") {
    ABExperiments.Tests = require("./abtest.json");
    ABExperiments.initializeTests();

    module.exports = ABExperiments;
}
